import React, { useState, useEffect, useCallback } from "react";
import { Loader } from "../CoreUI";
// import SurfaceOverlay from "../SurfaceOverlay";
import useResource from "../../hooks/useResource";
import { desktopOverlayUrl } from "../../conf";
import message from "../../utils/message";
import GET from "../../utils/GET";

import "./desktop-overlay.css";
import inFullscreen from "../../utils/inFullscreen";
import TrackerWrapper from "../TrackerWrapper";
import SurfaceManager from "../SurfaceManager";
import inDesktopOnly from "../../utils/inDesktopOnly";

const isModalWidget = GET("modal");
export default React.memo(({ callRewardApi, offsetTop, innerHeight }) => {
	const [fireLoadMessage, setFireLoadMessage] = useState(false);
	const [showLoader, setShowLoader] = useState(false);
	const handleClose = useCallback((key, length) => {
		setShowLoader(true);
		message({
			type: "DESKTOP_OVERLAY_CLOSE",
		});
	}, []);

	const [{ data, error }] = useResource(desktopOverlayUrl, {
		method: "POST",
		body: JSON.stringify({
			e: GET("email") || "",
			identifier: GET("identifier") || "",
			url: GET("host") || "",
			p: GET("purchases") || "",
			c: GET("cost") || "",
			shopify_discount_code: GET("shopifyDisCo") || "",
			shopify_checkout_token: GET("token") || "",
			shopify_order_id: GET("shopifyOrderID") || "",
		}),
		headers: {
			"Content-Type": "application/json",
		},
	});

	useEffect(() => {
		if (error) {
			message({ type: "DESKTOP_OVERLAY_UNMOUNT" });
		}
	}, [error]);

	useEffect(() => {
		if (data) {
			if (!data.display_order || data.display_order.length === 0) {
				return message({ type: "DESKTOP_OVERLAY_UNMOUNT" });
			}
			message({ type: "DESKTOP_OVERLAY_LOAD_COMPLETE" });
		}
	}, [data]);

	useEffect(() => {
		if (fireLoadMessage) {
			return;
		}
		message({ type: "DESKTOP_OVERLAY_LOAD" });
		setFireLoadMessage(true);
	}, [fireLoadMessage]);

	return (
		<TrackerWrapper data={data}>
			<section
				className="desktop-overlay-container"
				style={{
					backgroundColor:
						data?.publisher_details?.modal_color && inDesktopOnly
							? data?.publisher_details?.modal_color
							: "white",
				}}
			>
				{data &&
				data.display_order &&
				data.display_order.length !== 0 &&
				(!inFullscreen ||
					!data?.publisher_details?.post_purchase ||
					isModalWidget) ? (
					<>
						{/* {inDesktopOnly ? ( */}
						<section className="desktop-overlay-container-card">
							<SurfaceManager
								onClose={handleClose}
								data={data}
								rewardResponseTrigger={callRewardApi}
								desktop
								offsetTop={offsetTop}
								innerHeight={innerHeight}
							>
								{showLoader && <Loader center />}
							</SurfaceManager>
						</section>
						{/* ) : (
							<SurfaceOverlay
								onClose={handleClose}
								data={data}
								rewardResponseTrigger={callRewardApi}
								desktop
							>
								{showLoader && <Loader center />}
							</SurfaceOverlay>
						)} */}
					</>
				) : (
					<Loader center />
				)}
			</section>
		</TrackerWrapper>
	);
});
